import React from 'react';
import SummaryCard from '../components/Dashboard/SummaryCard';
import { Grid, Typography, CircularProgress } from '@mui/material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

const Dashboard = ({ debts, receivables, loans, loading }) => {
  // Garante que estamos trabalhando com arrays, mesmo que as props venham vazias
  const safeDebts = Array.isArray(debts) ? debts : [];
  const safeReceivables = Array.isArray(receivables) ? receivables : [];
  const safeLoans = Array.isArray(loans) ? loans : [];

  // --- LÓGICA DE CÁLCULO PARA OS CARDS ---

  // Card 1: "Dívidas Totais (A Pagar)" - Soma de todas as dívidas não pagas
  const totalDebtsToPay = safeDebts
    .filter(d => d.paid === false)
    .reduce((acc, d) => acc + parseFloat(d.amount), 0);

  // Card 2: "Recebimentos Previstos (Mês)" - Total planejado para receber no mês atual
  const currentMonth = new Date().getMonth();
  const currentYear = new Date().getFullYear();
  const totalReceivablesThisMonth = safeReceivables
    .filter(r => {
      if (!r.due_date) return false;
      const [year, month] = r.due_date.split('-').map(Number);
      return year === currentYear && (month - 1) === currentMonth;
    })
    .reduce((acc, r) => acc + parseFloat(r.amount), 0);

  // Card 3: "Empréstimos (A Receber)" - Soma de todos os empréstimos não pagos
  const totalLoansToReceive = safeLoans
    .filter(l => l.paid === false)
    .reduce((acc, l) => acc + parseFloat(l.total_with_interest), 0);
    
  // ================================================================
  // NOVA LÓGICA CORRIGIDA
  // Card 4: "Total a Receber (Geral)"
  // Esta é a soma de TUDO que você ainda tem para receber, de todas as fontes e de todos os tempos.

  // Primeiro, somamos TODOS os recebíveis que ainda não foram pagos (de qualquer mês)
  const totalUnpaidReceivablesAllTime = safeReceivables
    .filter(r => r.received === false)
    .reduce((acc, r) => acc + parseFloat(r.amount), 0);

  // Agora, somamos o total de recebíveis com o total de empréstimos
  const totalToReceiveFromAllSources = totalUnpaidReceivablesAllTime + totalLoansToReceive;
  // ================================================================


  if (loading) {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }}>
            <CircularProgress />
        </div>
    );
  }

  return (
    <>
      <Typography variant="h4" gutterBottom>
        Resumo Financeiro
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={3}>
          <SummaryCard 
            title="Dívidas Totais (A Pagar)" 
            amount={totalDebtsToPay} 
            icon={<ArrowDownwardIcon />}
            color="#F44336" // Vermelho
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <SummaryCard 
            title="Recebimentos Previstos (Mês)" 
            amount={totalReceivablesThisMonth} 
            icon={<ArrowUpwardIcon />}
            color="#4CAF50" // Verde
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <SummaryCard 
            title="Empréstimos (A Receber)" 
            amount={totalLoansToReceive} 
            icon={<MonetizationOnIcon />}
            color="#2196F3" // Azul
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <SummaryCard 
            title="Total a Receber (Geral)" 
            amount={totalToReceiveFromAllSources} 
            icon={<AccountBalanceWalletIcon />}
            color="#607D8B" // Cinza
          />
        </Grid>
      </Grid>
    </>
  );
};

export default Dashboard;